import { DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';
import { SchoolForm } from 'Src/models/form';
import { superAdminDelete, superAdminGet, superAdminPost, superAdminPut } from './api';

export interface SuperAdminFormsFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

export interface SuperAdminSchoolFormCreateData {
  name: string;
  age: number;
  pic?: string;
}

export interface SuperAdminSchoolFormUpdateData {
  name?: string;
  age?: number;
  pic?: string;
}

export interface SuperAdminSchoolFormStatusUpdateData {
  status: string;
}

const DEFAULT_FILTER: SuperAdminFormsFilter = {
  limit: LIMIT,
  skip: DEFAULT_SKIP,
  order: 'name ASC'
};

function buildFilter(filter: SuperAdminFormsFilter = DEFAULT_FILTER): SuperAdminFormsFilter {
  return {
    where: filter.where || {},
    skip: typeof filter.skip === 'number' ? filter.skip : DEFAULT_FILTER.skip,
    limit: typeof filter.limit === 'number' ? filter.limit : DEFAULT_FILTER.limit,
    order: filter.order || DEFAULT_FILTER.order
  };
}

export function getSuperAdminSchoolForms(
  schoolId: string,
  filter: SuperAdminFormsFilter = DEFAULT_FILTER
): Promise<SchoolForm[]> {
  return superAdminGet<SchoolForm[]>(`/schools/${schoolId}/forms`, {
    params: {
      filter: buildFilter(filter)
    }
  });
}

export function getAllSuperAdminSchoolForms(schoolId: string, where?: any): Promise<SchoolForm[]> {
  return superAdminGet<SchoolForm[]>(`/schools/${schoolId}/forms`, {
    params: {
      filter: {
        where: where || {},
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT,
        order: DEFAULT_FILTER.order
      }
    }
  });
}

export function getSuperAdminSchoolFormsCount(schoolId: string, where?: any): Promise<Count> {
  const config =
    typeof where !== 'undefined'
      ? {
          params: {
            filter: {
              where
            }
          }
        }
      : {};

  return superAdminGet<Count>(`/schools/${schoolId}/forms/count`, config);
}

export function getSuperAdminSchoolForm(schoolId: string, formId: string): Promise<SchoolForm> {
  return superAdminGet<SchoolForm>(`/schools/${schoolId}/forms/${formId}`);
}

export function createSuperAdminSchoolForm(
  schoolId: string,
  data: SuperAdminSchoolFormCreateData
): Promise<SchoolForm> {
  return superAdminPost<SchoolForm>(`/schools/${schoolId}/forms`, data);
}

export function updateSuperAdminSchoolForm(
  schoolId: string,
  formId: string,
  data: SuperAdminSchoolFormUpdateData
): Promise<SchoolForm> {
  return superAdminPut<SchoolForm>(`/schools/${schoolId}/forms/${formId}`, data);
}

export function updateSuperAdminSchoolFormStatus(
  schoolId: string,
  formId: string,
  status: string
): Promise<SchoolForm> {
  return superAdminPut<SchoolForm>(`/schools/${schoolId}/forms/${formId}/status`, { status });
}

export function deleteSuperAdminSchoolForm(schoolId: string, formId: string): Promise<void> {
  return superAdminDelete<void>(`/schools/${schoolId}/forms/${formId}`);
}
